<template>
  <v-container class="overlay">
    <v-layout
      align-center
      justify-center
      column
    >
      <v-flex class="none-outstanding">
        <h1>{{ strings.noneOutstanding }}</h1>
      </v-flex>
      <v-flex class="none-outstanding">
        <v-btn
          color="primary"
          dark
          @click="onGoToGroups"
        >
         {{ strings.returnToGroups }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters("page", ["strings"])
  },
  methods: {
    onGoToGroups() {
      this.$router.push({ name: "group" }).catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.overlay {
  position: fixed;
  height: 100%;
  width: 100%;
  padding-top: 30vh;
  z-index: 5;
  max-width: unset;
}

.overlay .none-outstanding {
  background-color: var(--v-background-base);
  padding: 3%;
  width: 75vw;
  height: 10vh;
  color: #fff;
}

.overlay .none-outstanding-icon {
  background-color: var(--v-background-base);
  padding: 1%;
  color: #005387;
}
</style>
